import { Button } from '@repo/foundations';
import { closeAllModals, openModal } from '../ModalManager';
import { DataAccessRequestCreateModal } from './DataAccessRequestCreateModal/DataAccessRequestCreateModal';

export function AddRequestButton() {
	const handleOpenModal = () => {
		openModal({
			title: 'Request access',
			centered: true,
			children: <DataAccessRequestCreateModal onClose={closeAllModals} />,
		});
	};

	return (
		<Button onClick={handleOpenModal} variant="primary">
			Create request
		</Button>
	);
}
